import { customerInTrial, customerTrialEnded } from 'src/data/customer';
import { getCustomerPlan, isPlanFromBasicCategory } from 'src/data/subscription';

import { useCurrentCustomer } from './useCurrentCustomer';

export const useIsCustomerOnBasicPlan = () => {
  const currentCustomer = useCurrentCustomer();
  const isCustomerInTrial = customerInTrial(currentCustomer) || customerTrialEnded(currentCustomer);
  const plan = getCustomerPlan(currentCustomer);
  return isPlanFromBasicCategory(plan) && !isCustomerInTrial;
};
